module.exports = __webpack_public_path__ + "img/medium_armor_1.26d61aa1.png";